import { formatDate } from "@/utils/dateUtils"
import "./style.css"
import { useEffect, useState } from "react"

export const CombinedRequestCell = ({ main, sub, mainClassName, subClassName }) =>
    <div className='combined-request-cell'>
        <span className={mainClassName}>{main}</span>
        <span className={subClassName}>{sub}</span>
    </div>



export const NameRequestCell = ({ original }) =>
    <CombinedRequestCell main={original.patientName} sub={`# ${original.requestId}`} mainClassName='patient-name' subClassName='patient-id' />


export const CategoryRequestCell = ({ original }) =>
    <CombinedRequestCell main={original.categoryName} sub={original.subCategoryName} mainClassName='category-request-cell' subClassName='sub-category-request-cell' />

